import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/chart";
import { dailyLabelFormatter } from "@/components/chart-template";
import { Area, CartesianGrid, ComposedChart, Line, XAxis, YAxis } from "recharts";
import { ChartData } from "./secondary-cpa";

const secondaryCPALabelBase = "CPA €";
const targetSecondaryCPALabelBase = "Target CPA €";

const chartConfig = {
  secondary_cpa: {
    label: secondaryCPALabelBase,
    color: "hsl(var(--chart-1))",
  },

  secondary_ap_target_cpx_eur: {
    label: targetSecondaryCPALabelBase,
    color: "hsl(var(--chart-2))",
  },
} satisfies ChartConfig;

type PerformanceChartProps = {
  chartData: ChartData;
};

function SecondaryCPAAchievementChart({ chartData }: PerformanceChartProps) {
  const labelFormatter = (value: string) => {
    return dailyLabelFormatter(value);
  };

  let maxRange = chartData.reduce((max, item) => {
    return Math.max(max, item.secondary_cpa, item.secondary_ap_target_cpx_eur);
  }, 0);

  maxRange = Math.ceil(maxRange * 1.1);

  const data = chartData;
  return (
    <ChartContainer config={chartConfig}>
      <ComposedChart data={data}>
        <CartesianGrid vertical={false} />
        <XAxis dataKey="dateTime" tickLine={false} axisLine={false} tickMargin={8} tickFormatter={labelFormatter} />
        <YAxis
          dataKey="secondary_cpa"
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          domain={[0, maxRange]} // 10% more than max value
          tickFormatter={(value: number) => {
            return `€ ${value}`;
          }}
        />
        <ChartTooltip cursor={false} content={<ChartTooltipContent labelFormatter={labelFormatter} />} />
        <Line dataKey="secondary_cpa" type="linear" stroke="var(--color-secondary_cpa)" strokeWidth={2} dot={false} />
        <Area
          dataKey="secondary_ap_target_cpx_eur"
          type="monotone"
          fill="var(--color-secondary_ap_target_cpx_eur)"
          fillOpacity={0.2}
          stroke="var(--color-secondary_ap_target_cpx_eur)"
          strokeWidth={2}
          dot={false}
        />
        <ChartLegend content={<ChartLegendContent />} />
      </ComposedChart>
    </ChartContainer>
  );
}

export default SecondaryCPAAchievementChart;
